import type { JSX, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getUser } from "../lib/auth";
import { reviewerRedirect } from "./reviewGuard";

/** Route guard for the /review console: admin ∪ agent only. */
export function RequireReviewer({ children }: { children: ReactNode }): JSX.Element {
  const dest = reviewerRedirect(getUser());
  if (dest !== null) return <Navigate to={dest} replace />;
  return <>{children}</>;
}
